"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _UserAvatar = _interopRequireDefault(require("../User/UserAvatar"));

var _UserName = _interopRequireDefault(require("../User/UserName"));

var _Loader = _interopRequireDefault(require("@insided/deprecated-control/ui-components/Loader"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var EventAttendees = function EventAttendees(_ref) {
  var attendeeCount = _ref.attendeeCount,
      attendees = _ref.attendees,
      page = _ref.page,
      isLoading = _ref.isLoading,
      loadNextPage = _ref.loadNextPage,
      isEventEngagementEnabled = _ref.isEventEngagementEnabled,
      isPastEvent = _ref.isPastEvent;
  var showMoreButton = page * 6 < attendeeCount;
  if (!isEventEngagementEnabled) return null;
  if (isPastEvent && attendeeCount === 0) return null;
  return (0, _preact.h)("div", {
    className: "event-attendees-container"
  }, (0, _preact.h)("div", {
    className: "event-attendees__header_label"
  }, (0, _preact.h)(_phrase.default, {
    p: "events.attendees",
    m: "Forum"
  }), " (", attendeeCount, ")"), (0, _preact.h)("div", {
    className: "event__attendees"
  }, attendees.map(function (attendee) {
    return (0, _preact.h)("div", {
      key: attendee.name,
      className: "attendee"
    }, (0, _preact.h)(_UserAvatar.default, {
      user: attendee,
      showRank: true
    }), (0, _preact.h)("div", null, (0, _preact.h)(_UserName.default, {
      user: attendee
    }), attendee.rank ? (0, _preact.h)("div", {
      className: "text--meta"
    }, attendee.rank.name) : null));
  }), attendees.length === 0 && (0, _preact.h)("div", {
    className: "no-attendees-placeholder"
  }, (0, _preact.h)(_phrase.default, {
    p: "events.attendees.none",
    m: "Forum"
  })), isLoading ? (0, _preact.h)(_Loader.default, null) : null), showMoreButton && (0, _preact.h)("div", {
    className: "show-more-attendees"
  }, (0, _preact.h)("button", {
    className: "btn btn-primary",
    onClick: function onClick() {
      return loadNextPage();
    }
  }, "Show more")));
};

var _default = EventAttendees;
exports.default = _default;